var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Spain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M24,4C16.602,4,10.157,8.028,6.697,14h34.605C37.843,8.028,31.398,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M41.302,34H6.698c3.46,5.972,9.904,10,17.302,10S37.843,39.972,41.302,34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M44,24c0-3.647-0.992-7.056-2.697-10H6.697C4.992,16.944,4,20.353,4,24s0.992,7.056,2.698,10h34.605 C43.008,31.056,44,27.647,44,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Spain);
export default __webpack_public_path__ + "static/media/icons8-spain.8d97b3cc60806e10453fabcab4b77440.svg";
export { ForwardRef as ReactComponent };